var Curriculog = Curriculog || {};

Curriculog.UserRoleFlyoutView = (function ($, _, Backbone, UserRoleFlyoutView) {

	var UserRoleFlyoutView = Curriculog.CurriculogView.extend({
		initialize: function (options) {
			this.userRole = options.userRole;
			this.users = options.users;
			this.roles = options.roles;
			this.committees = options.committees;
			this.agendaAdmins = options.agendaAdmins;
			this.canDelete = options.canDelete;
			this.isAgendaAdmin = options.isAgendaAdmin;

			this.userID = this.userRole.get('user_id');
			this.user = this.users.get(this.userID);
			this.sanitizeAttributes();

			this.roleID = this.userRole.get('role_id');
			this.role = this.roles.get(this.roleID);

			this.committeeID = this.role.get('committee_id');
			this.committee = this.committees.get(this.committeeID);
      this.params = options.params;

			this.flyoutTitle = new Curriculog.UserRoleFlyoutTitleView({
				users: this.users,
				roles: this.roles,
				model: this.userRole,
        params: this.params
			});

	        this.manageUserRoleBasic = new Curriculog.ManageUserRolesBasicView({
	            user: this.user,
	            users: this.users,
	            role: this.role,
	            userRole: this.userRole,
	            committee: this.committee,
	            agendaAdmin: options.isAgendaAdmin,
	            agendaAdmins: this.agendaAdmins,
	            canDelete: this.canDelete,
	        });

	        this.render();
		},

		render: function () {
			this.$el.append(this.flyoutTitle.el);
			this.$el.append(this.manageUserRoleBasic.el);
		},

		cleanup: function () {
			this.flyoutTitle.remove();
			this.manageUserRoleBasic.remove();
			this.remove();
		},

		sanitizeAttributes: function () {
			tags = {
				'<script>' : '&lt;script&gt;',
				'</script>' : '&lt;/script&gt;',
				'<SCRIPT>' : '&lt;SCRIPT&gt;',
				'</SCRIPT>' : '&lt;/SCRIPT&gt;'
			};

			for(tag in tags) {
				if(this.user.attributes.first_name.includes(tag)){
					this.user.attributes.first_name = this.user.attributes.first_name.replaceAll(tag, tags[tag]);
				};
				if(this.user.attributes.last_name.includes(tag)){
					this.user.attributes.last_name = this.user.attributes.last_name.replaceAll(tag, tags[tag]);
				}
			};
		},
	});

	return UserRoleFlyoutView;

})($, _, Backbone, Curriculog.UserRoleFlyoutView || {});
